// @flow

import React from 'react'
import Dropzone from 'react-dropzone'
import { newMinLengthValidator, newMaxLengthValidator } from '../../../helpers'
import { hoverable } from '../../utils'
import OpinaryInput from '../../Controls/OpinaryInput'
import Condition from '../../Condition'

type Props = {
  option: Object,
  onDrop: Function,
  onNameChange: Function,
  onRemove: Function,
  onRemoveImage: Function,
  hovered: boolean,
}

type State = {
  minLengthError: boolean,
  maxLengthError: boolean,
}

export class Option extends React.Component<Props, State> {
  props: Props
  state: State

  state = {
    minLengthError: false,
    maxLengthError: false,
  }

  errorTimeout: number = -1

  componentWillUnmount() {
    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout)
    }
  }

  onNameChange(name: string) {
    const minLengthError = newMinLengthValidator(1, 'Name')(name)
    const maxLengthError = newMaxLengthValidator(35, 'Name')(name)

    if (minLengthError) {
      this.setState({ minLengthError: true })
    } else {
      this.props.onNameChange(name)
      this.setState({ minLengthError: false })
    }

    if (maxLengthError) {
      this.setState({ maxLengthError: true })
    } else {
      this.props.onNameChange(name)
      this.setState({ maxLengthError: false })
    }
  }

  render() {
    const { option, onDrop, onRemove, hovered } = this.props
    const { image } = option
    const maxError = newMaxLengthValidator(36)
    const dropZoneStyles = {
      style: {
        paddingTop: '100%',
        backgroundColor: '#cccccc',
        cursor: 'pointer',
        position: 'relative',
        backgroundImage: image ? `url('${image}')` : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      },
      activeStyle: {
        borderStyle: 'solid',
        backgroundColor: '#eee',
      },
      rejectStyle: {
        borderStyle: 'solid',
        backgroundColor: '#ffdddd',
      },
    }

    return (
      <div
        style={{ padding: '8px' }}
        className={`${hovered ? 'b--op-con-medium ba bw1 relative' : ''}`}
      >
        {hovered ? (
          <div
            className="absolute bg-op-con-medium white flex justify-center items-center pointer"
            style={{
              top: '-15px',
              right: '-15px',
              width: '30px',
              height: '30px',
            }}
            onClick={onRemove}
          >
            <i className="fa fa-times"></i>
          </div>
        ) : null}

        <OpinaryInput
          id={`option-${option.position}-name`}
          placeholder="Name"
          className="mb2"
          inputClass="tc w-100"
          value={option.name}
          onChange={event => this.onNameChange(event.target.value)}
          maxLength={36}
          borderClass={maxError(option.name) ? 'b--dark-red' : 'b--moon-gray'}
        />

        <Condition shouldRender={this.state.minLengthError}>
          <div className="tl dark-red mt2">Field cannot be empty</div>
        </Condition>
        <Condition shouldRender={this.state.maxLengthError}>
          <div className="tl dark-red mt2">
            Field cannot exceed 35 characters
          </div>
        </Condition>

        <Dropzone
          multiple={false}
          accept="image/*"
          onDrop={files => onDrop(files[0])}
          {...dropZoneStyles}
        >
          {image ? null : (
            <div className="absolute top-0 w-100 h-100 f6 flex items-center justify-center tc ph1">
              Drag an image or click to upload
            </div>
          )}

          {image && hovered ? (
            <div className="w-100 h-100 absolute top-0 left-0 bg-black-30 flex items-center justify-center white f6 ph1 tc">
              <span className="mb2">Click to replace image</span>
            </div>
          ) : null}
        </Dropzone>
      </div>
    )
  }
}

export default hoverable(Option)



// WEBPACK FOOTER //
// ./src/components/PollForm/RankingPollForm/Option.js